module.exports = __webpack_public_path__ + "static/Syberia4-126c9b5a9037ca061ba1636e1d3b920a.png";